import { ACTION_SUFFIX } from "../../../../lib/constants";
import { SuffixPathnameNormalizer } from "./suffix";
export class ActionPathnameNormalizer extends SuffixPathnameNormalizer {
    constructor(){
        super(ACTION_SUFFIX);
    }
}

//# sourceMappingURL=action.js.map